import { Stack } from "expo-router";
import TrafficFlowScreen from "@src/features/traffic-flow/screens/TrafficFlowScreen.web";

export default function TenantTrafficFlowScreen() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <TrafficFlowScreen />
    </>
  );
}
